module.exports = __webpack_public_path__ + "static/media/reformer5.c49d8510.jpg";